import { render, staticRenderFns } from "./UserConfig.vue?vue&type=template&id=3d5f12c9&"
import script from "./UserConfig.vue?vue&type=script&lang=js&"
export * from "./UserConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports